export default {
  presenter: 'ziegler',
  title: 'Síťové simulátory - navrhněme a otestujme si malou síť',
  subtitle: 'mírně pokročilí',
  text: `
Doplnění k přednášce Síťové simulátory letem světem.  
Pojďme si zkusit navrhnout a otestovat malou LAN síť v simulátoru GNS3 a také si vyzkoušet, jak v
takové síti zabránit smyčkám pomocí Spanning Tree Protokolu. Když nám to půjde dobře, tak zkusíme
k naší simulované síti, připojit i skutečný switch.
  `,
}



// WEBPACK FOOTER //
// ./src/content/installfest/data/presentations/ziegler-sitove-simulatory-ws.js